/**
 * What a click on the planner's map is for, when it lands on several things
 * at once. A hike highlight wins over the map's own place icon it sits on —
 * the highlight's sheet has "Place details" for the place — wherever either
 * is in the stack of features under the click.
 */
export type MapClickTarget = 'highlight' | 'poi' | null;

interface RenderedFeatureLike {
  source?: string;
  layer?: { id?: string };
}

export function mapClickTarget(rendered: RenderedFeatureLike[]): MapClickTarget {
  if (rendered.some(feature => feature.layer?.id?.startsWith('highlight-'))) return 'highlight';
  const top = rendered[0];
  if (top?.source && top.source !== 'hover-point' && top.source.includes('poi')) return 'poi';
  return null;
}
